export default "__VITE_PUBLIC_ASSET__c18f787d__"